import image from "../../images/websiteImage.jpg";

const data = [
  {
    id: 1,
    titleProject: "project for testing",
    descProject:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed deiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim adminim veniam, quis nostrud exercitation ullamco.",
    image: image,
    category: "InterfaceDesign",
  },
  {
    id: 2,
    titleProject: "project for testing",
    descProject:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed deiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim adminim veniam, quis nostrud exercitation ullamco.",
    image: image,
    category: "website",
  },
  {
    id: 3,
    titleProject: "project for testing",
    descProject:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed deiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim adminim veniam, quis nostrud exercitation ullamco.",
    image: image,
    category: "mobileApp",
  },
  {
    id: 4,
    titleProject: "project for testing",
    descProject:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed deiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim adminim veniam, quis nostrud exercitation ullamco.",
    image: image,
    category: "graphicDesigns",
  },
  {
    id: 5,
    titleProject: "project for testing",
    descProject:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed deiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim adminim veniam, quis nostrud exercitation ullamco.",
    image: image,
    category: "graphicDesigns",
  },
  {
    id: 6,
    titleProject: "project for testing",
    descProject:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed deiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim adminim veniam, quis nostrud exercitation ullamco.",
    image: image,
    category: "website",
  },
];

export default data;
